import React from 'react';
import Card from '../../styled/Card/Card';
import TemplateConfig from '../TemplateConfig';
import TemplateList from '../TemplateList';
import { SidebarInner, SidebarWrapper } from './Sidebar.styles';

interface SidebarProps {}

const Sidebar: React.FC<SidebarProps> = () => (
  <SidebarWrapper>
    <SidebarInner>
      <TemplateConfig />
      {/* <TemplateList /> */}
    </SidebarInner>
  </SidebarWrapper>
);

export default Sidebar;
